export const DEFAULT_EMPLOYEE_TYPE_SETTING_ID =
    '83DD3D0D-4483-41D5-B579-AC23600012FF';
export const EMPLOYEE_TYPE_OWNER_ID = '477ef817-4752-450b-8e2e-a1d3685f273a';

export const AI_ASSISTANT_ROLE = 'assistant';

export const USER_ROLE = 'user';
